import { render } from "./AboutPolarad.vue?vue&type=template&id=54010c87&scoped=true"
import script from "./AboutPolarad.vue?vue&type=script&lang=js"
export * from "./AboutPolarad.vue?vue&type=script&lang=js"

import "./AboutPolarad.vue?vue&type=style&index=0&id=54010c87&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54010c87"]])

export default __exports__